<template>
  <ZMainPage type="card">
    <div class="info-item">
      <div class="z-box-bg brl">
          <SearchBlock ref="SearchDom" :search-config="searchConfig" @onSearch="onSearch" @onReset="onReset"></SearchBlock>
          <div class="show-box" v-loading="loading">
            <div class="show-box-list">
              <template v-if="list1.length">
                <div class="show-item" v-for="(item, i) in list1" :key="i">
                  <div class="label">{{ item.label }}</div>
                  <div class="value">
                    <span class="num">{{ item.value }}</span>
                    <span class="unit" v-if="item.unit">{{ item.unit }}</span>
                  </div>
                </div>
              </template>
              <t-result v-else></t-result>
            </div>
          </div>
      </div>
    </div>
    <div class="info-item">
      <div class="info-item-title">辅导学生人数</div>
      <div class="z-box-bg brl full-box" v-loading="loading">
        <div v-if="option1" class="inner-box" ref="chart1"></div>
        <t-result v-else></t-result>
      </div>
    </div>
    <div class="info-item">
      <div class="info-item-title">平均字数</div>
      <div class="z-box-bg brl" v-loading="loading">
        <div class="page-tabs">
          <div :class="['page-tabs-item', index === 0 && 'active']" @click="handleChangeIndex(0)">监督内容</div>
          <div :class="['page-tabs-item', index === 1 && 'active']" @click="handleChangeIndex(1)">辅导内容</div>
        </div>
        <div class="full-box">
          <div v-if="option2" class="inner-box" ref="chart2"></div>
          <t-result v-else></t-result>
        </div>
      </div>
    </div>
    <div class="info-item flex pl">
      <div class="flex-1">
        <div class="info-item-title">完成情况评分</div>
        <div class="z-box-bg brl small-box" v-loading="loading">
          <div v-if="option3" class="inner-box" ref="chart3"></div>
          <t-result v-else></t-result>
        </div>
      </div>
      <div class="flex-1 mx-2">
        <div class="info-item-title">辅导类型占比</div>
        <div class="z-box-bg brl small-box" v-loading="loading">
          <div v-if="option4" class="inner-box" ref="chart4"></div>
          <t-result v-else></t-result>
        </div>
      </div>
      <div class="flex-1">
        <div class="info-item-title">本期榜单</div>
        <div class="z-box-bg brl small-box" v-loading="loading">
          <div v-if="list2.length">
            <div class="list-item bg">
              <div class="td">排名</div>
              <div class="td">姓名</div>
              <div class="td">平均字数</div>
            </div>
            <div class="list-item my-1" v-for="(item, index) in list2" :key="index">
              <div class="td num" :data-num="index + 1"></div>
              <div class="td">{{ item.clerk_name }}</div>
              <div class="td">{{ item.total }}</div>
            </div>
          </div>
          <t-result v-else></t-result>
        </div>
      </div>
    </div>
    <div class="info-item flex">
      <div class="mr-2 flex-1 flex align-stretch">
        <div class="z-box-bg brl flex-1">
          <div class="info-item-title no flex justify-between">
            <div>
              <span class="gray mr-3">当前未完成任务教师名单</span>
              <span class="num">{{ total1 }}</span>
            </div>
            <div class="arrow-box" v-if="tableData1.length">
              <i :class="['el-icon-caret-left', { 'disable': loading1 || page1 === 1 }]" @click="handleClick(0, 0)"></i>
              <i :class="['el-icon-caret-right', { 'disable': loading1 || last_page1 === page1 }]" @click="handleClick(0, 1)"></i>
            </div>
          </div>
          <div class="flex-1">
            <el-table v-if="tableData1.length" border :stripe="false" :data="tableData1" v-loading="loading1" size="small">
              <el-table-column prop="teacher" label="姓名" align="center" width="160"></el-table-column>
              <el-table-column prop="class" label="班级" align="center"></el-table-column>
              <el-table-column prop="complete_rate" label="完成率" align="center" width="160">
                <template #default="scope"><span>{{ scope.row.complete_rate }}%</span></template>
              </el-table-column>
            </el-table>
            <t-result v-else></t-result>
          </div>
        </div>
      </div>
      <div class="flex-1 flex align-stretch">
        <div class="z-box-bg brl flex-1">
          <div class="info-item-title no flex justify-between">
            <div>
              <span class="gray mr-3">提交班级周报教师名单</span>
              <span class="num">{{ total2 }}</span>
            </div>
            <div class="arrow-box" v-if="tableData2.length">
              <i :class="['el-icon-caret-left', { 'disable': loading2 || page2 === 1 }]" @click="handleClick(1, 0)"></i>
              <i :class="['el-icon-caret-right', { 'disable': loading2 || last_page2 === page2 }]" @click="handleClick(1, 1)"></i>
            </div>
          </div>
          <div class="flex-1">
            <el-table v-if="tableData2.length" border :stripe="false" :data="tableData2" v-loading="loading2" size="small" >
              <el-table-column prop="teacher" label="姓名" align="center" width="160"></el-table-column>
              <el-table-column prop="class" label="班级" align="center"></el-table-column>
              <el-table-column prop="submit_at" label="提交日期" align="center" width="160"></el-table-column>
            </el-table>
            <t-result v-else></t-result>
          </div>
        </div>
      </div>
    </div>
  </ZMainPage>
</template>
<script>
import SearchBlock from "@/components/SearchBlock"
import * as Echarts from 'echarts'
import { getApi2, get_grade2, get_school2 } from "@/api";
export default {
	_config:{"route":{"path":"index","meta":{"title":"数据展示"}}},
  components: { SearchBlock },
  data() {
    // 这里存放数据
    return {
      index: 0,
      dataList: [],
      list1: [],
      list2: [],
      tableData1: [],
      tableData2: [],
      loading: false,
      loading1: false,
      loading2: false,
      page1: 1,
      page2: 1,
      last_page1: 1,
      last_page2: 1,
      total1: 0,
      total2: 0,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      template1: {
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: { type: 'value' },
        legend: {
          orient: 'horizontal',
          bottom: '20',
          itemGap: 60,
          textStyle: {
            fontSize: '14rem',
            color: '#3C3C3C'
          },
          data: []
        },
        color: ['#2FD932', '#BBCBFF', '#AB87FF', '#EA8533', '#FD3D80'],
        grid: { left: '3%', right: '4%', bottom: '70', containLabel: true },
        series: []
      },
      template2: {
        tooltip: { trigger: 'item' },
        legend: {
          bottom: '5',
          left: 'center',
          itemGap: 40,
          textStyle: {
            fontSize: '14rem',
            color: '#3C3C3C'
          }
        },
        color: ['#FF4D4D', '#FE9454', '#2FD931', '#8F5FFF', '#B1C3FF'],
        series: [
          {
            name: '',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['30%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 6
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      },
      search: {},
      searchConfig: [
        {
          tag: 'select',
          placeholder: '筛选周期',
          prop: 'start_end_date',
          options: [],
          default: ''
        },
        {
          tag: 'select',
          placeholder: '筛选校区',
          prop: 'school_id',
          options: [],
          change: (val, search) => {
            this.search = search
            if (search.grade_id) this.search.grade_id = ''
          }
        },
        {
          tag: 'select',
          placeholder: '筛选年级',
          prop: 'grade_id',
          options: [],
        }
      ]
    }
  },
  // 计算属性 类似于 }data 概念
  computed: {},
  // 监控 data 中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getConfig() {
      get_school2().then(res => {
        const list = res.map(item => ({label: item.school_name, value: item.id}))
        this.searchConfig[1].options = list
      })
      get_grade2().then(res => {
        const list = res.map(item => ({label: item.name, value: item.id}))
        this.searchConfig[2].options = list
      })
      this.loading = true
      getApi2('/teacher/moral-educationController/pc-cycle', { size: 4 }).then(res => {
        this.searchConfig[0].options = res.map(item => ({ label: item.day_start + ' - ' + item.day_end, value: item.day_start + '~' + item.day_end}))
        this.getDate()
        this.$refs.SearchDom.reset()
      }).finally(() => this.loading = false)
    },
    getDate() {
      if(!this.search.start_end_date) {
        const arr = this.searchConfig[0].options
        this.search.start_end_date = arr[0]?.value ?? ''
        this.searchConfig[0].default = this.search.start_end_date
      }
    },
    getData() {
      this.getDate()
      this.page1 = 1
      this.page2 = 1
      this.total1 = 0
      this.total2 = 0
      this.getEChartData()
      this.getList1()
      this.getList2()
    },
    getEChartData() {
      this.loading = true
      getApi2('/teacher/moral-statistic/tea-work-profile', this.search).then(res => {
        const { student_number_curve, avg_coach_content_curve, avg_supervise_curve, score_pie, coach_pie, word_rankings } = res
        this.list1 = [
          { label: '辅导任务完成率', value: res.complete_rate, unit: '%' },
          { label: '监督内容平均字数', value: res.avg_supervise },
          { label: '辅导内容平均字数', value: res.avg_coach_content },
          { label: '已辅导学生覆盖率', value: res.student_complete_rate, unit: '%' },
          { label: '已辅导学生人数', value: res.student_number },
          { label: '完成任务教师人数', value: res.teacher_number },
          { label: '班级周报', value: res.class_week_number }
        ]
        this.list2 = word_rankings

        const option1 = JSON.parse(JSON.stringify(this.template1))
        const option2 = JSON.parse(JSON.stringify(this.template1))
        const option3 = JSON.parse(JSON.stringify(this.template2))
        const option4 = JSON.parse(JSON.stringify(this.template2))

        const data1 = student_number_curve.data || []
        const series1 = student_number_curve.series || []
        const names1 = series1.map(item => item.name)

        const data2 = avg_coach_content_curve.data || []
        const series2 = avg_coach_content_curve.series || []
        const names2 = series2.map(item => item.name)

        const data2_2 = avg_supervise_curve.data || []
        const series2_2 = avg_supervise_curve.series || []
        const names2_2 = series2_2.map(item => item.name)
        this.index = 0
        this.dataList = [{ data: data2_2, series: series2_2, names: names2_2},{ data: data2, series: series2, names: names2}]

        option1.xAxis.data = data1
        option1.legend.data = names1
        option1.series = series1

        option2.xAxis.data = data2_2
        option2.legend.data = names2_2
        option2.series = series2_2

        option3.series[0].data = score_pie
        option4.series[0].data = coach_pie

        this.option1 = null
        this.option2 = null
        this.option3 = null
        this.option4 = null

        setTimeout(() => {
          this.option1 = series1.length ? option1 : null
          this.option2 = series2.length ? option2 : null
          this.option3 = score_pie.length ? option3 : null
          this.option4 = coach_pie.length ? option4 : null

          this.$nextTick(() => {
            this.init()
            this.option1 && this.chart1.setOption(option1)
            this.option2 && this.chart2.setOption(option2)
            this.option3 && this.chart3.setOption(option3)
            this.option4 && this.chart4.setOption(option4)
          })
        }, 50);
      }).finally(() => this.loading = false)
    },
    getList1() {
      this.loading1 = true
      getApi2('/teacher/moral-statistic/work-profile-teacher', {...this.search, page: this.page1}).then(res => {
        const { list = [], page = {} } = res
        this.tableData1 = list
        const { current_page = 1, last_page = 1, total = 0 } = page
        this.page1 = current_page
        this.last_page1 = last_page
        this.total1 = total
      }).finally(() => this.loading1 = false)
    },
    getList2() {
      this.loading2 = true
      getApi2('/teacher/moral-statistic/work-profile-class', {...this.search, page: this.page2}).then(res => {
        const { list = [], page = {} } = res
        this.tableData2 = list
        const { current_page = 1, last_page = 1, total = 0 } = page
        this.page2 = current_page
        this.last_page2 = last_page
        this.total2 = total
      }).finally(() => this.loading2 = false)
    },
    handleClick(table, type) {
      // 数据请求中返回
      if((this.loading1 && !table) || (this.loading2 && table)) return
      let page = table ? this.page2 : this.page1
      let last = table ? this.last_page2 : this.last_page1
      page += type ? 1 : -1
      // 页码越界处理
      if(page < 1 || page > last) return
      if(table) {
        this.page2 = page
        this.getList2()
      } else {
        this.page1 = page
        this.getList1()
      }
    },
    init() {
      this.$refs.chart1 && (this.chart1 = Echarts.init(this.$refs.chart1))
      this.$refs.chart2 && (this.chart2 = Echarts.init(this.$refs.chart2))
      this.$refs.chart3 && (this.chart3 = Echarts.init(this.$refs.chart3))
      this.$refs.chart4 && (this.chart4 = Echarts.init(this.$refs.chart4))
    },
    resize() {
      this.chart1.resize()
      this.chart2.resize()
      this.chart3.resize()
      this.chart4.resize()
    },
    onSearch(search) {
      setTimeout(() => {
        this.search = {...search}
        this.getData()
      }, 50)
    },
    onReset() {
      this.search = {}
    },
    handleChangeIndex(idx) {
      if(this.index === idx) return
      this.index = idx
      this.option2 = null
      const option2 = JSON.parse(JSON.stringify(this.template1))
      const { data = [], names = [], series = [] } = this.dataList[idx] || {}
      option2.xAxis.data = data
      option2.legend.data = names
      option2.series = series
      this.option2 = series.length ? option2 : null
      this.$nextTick(() => {
        if(this.$refs.chart2) {
          if(this.chart2) {
            this.chart2.dispose()
            this.chart2 = null
          }
          this.chart2 = Echarts.init(this.$refs.chart2)
          this.chart2.setOption(option2)
          this.option2 && this.chart2.setOption(option2)
        }
      })
    }
  },
  created() {
    this.getConfig()
  },
  mounted() {
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>
<style lang="scss" scoped>
.info-item {
  &:not(:last-child) {
    margin-bottom: 24rem;
  }
  &-title {
    margin-bottom: 20rem;
    font-size: 24rem;
    line-height: 34rem;
    color: #1e3aa2;
    &.no {
      &::before {
        content: none;
      }
    }
    .gray {
      color: #3C3C3C;
    }
    .ds {
      color: #aaa;
      font-size: 16rem;
    }
    .num {
      color: #326FFF;
    }
    .arrow-box {
      color: #aaa;
      i {
        cursor: pointer;
        &:hover {
          color: #1e3aa2;
        }
        &.disable {
          cursor: not-allowed;
          color: #ddd;
        }
      }
    }
    &::before {
      width: 20rem;
      height: 20rem;
      margin-left: 10rem;
      margin-right: 16rem;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA8lJREFUaEPtmV1O20AQgGfWG6S+wRtSXCncIJyg8Fo1fyconAA4AXAC4ASkJ8BJqr6SnoDcgEhNJN6at0rE3mk2vyaxvbOOEQrCT3kYr+ebmZ2/IGz4gxuuP3wAvLUHM/fAbvVfIRfkiipQ3f6vrY4GzH99LqLAbSllp+vhIEvoTADcb8MDcJwTIDoAgO2Jguqy18xd6F9ueXgBIM6nig8IwROKGn9a0lsXJjVAoUrbvvJPAcTJQumwOrEAcyEC6CLADynEdVrPpALIl/wjRLyKVnymnxlgJqlBgOiy35J1W49YAYytHtAtIFXNH+IDLFyCnnTw2MYbbIDdKhWkUncAUDQrn3gHEl/X3giEOHzysMv5DgtAK+8odY8ABc6hhktsPMIGwgigw2ao1IOd8uk9EL4XOSH2TeFkBHBL6o4X88uGTXEHlo8g9HotUUtyWSLANNvcGn0eKZABAAAQ0XFSdooFSB869mnUYKCBFGIvLpRiAdxyoKvorHrynUDUBqTfUsh5cZpmsAoAHPGzWHRRXFYkFiBfDh4tL+4AlKr1fubaSbSfS35VIV7Znt1rOjtR50YC6I8Qos753KfjC1Hj5m77mqJbK3UYZZxIgHwluEUau9v42OTs8GFTiIfkdiT0BqLXa6xmpEgAtxz85R6MRLW0XeW4ixXi3milicAgKoxWACZdptIAnKfTazr7HME4Gbfk3wOibsONjy+e9568Ty9ajBUAS6ucjqxyY/xygsDSrJB4VJS3VwDG05NERrcJ4AtZ517cOM0Wc4XZDOSTN5vyZtLGVsJ87NtKvD8AmxAKV9u0fpikU5+XsjkhZFfEFg1bWoBRytYz9TXr/YhithJCei0i1dYj60Cidq8lD1myMUJuOdDFjDXlSSF2lpu6tQtZXInnQNl5m1nI9IfdiroD4gzukwrpC7Fvm05tx1RCqPcbzvGyYaI9YFfi9Zmv3szFtSxJ8wC7H9IEuqkTRGemvmha6XWnO93gmYNNn91vOntRkgkAL9aB5q8sJPQ+tD4Kq8YsrObVlvALt+9Z+uBlr+mM15SsENJC06ZOZyO2pV4entFMDNBN2k6836F+Zs2NXqvMQmmjF1sawjZnT7yX/g7YjKnsbtQeIh2AjfLaTGyAeWba1PV6OEXqlSMgnifvdqw8MCCis1f/gyMMMa0TpwTwPRqEBTAAUDfrzBVWIRRXjsfbNoEVJNCztPFPvlE1bkMQ3Ji2eJzynwnAimd8v0iKBuG/WYUjCkNn2Flei3CUTJLJHGBdhWzf/wCwtVjW8hvvgf8/YExPeqjI1gAAAABJRU5ErkJggg==');
    }
  }
}
.show {
  &-box {
    &-list {
      display: flex;
      flex-wrap: wrap;
    }
  }
  &-item {
    width: 190rem;
    padding: 24rem 15rem;
    margin-top: 16rem;
    margin-bottom: 16rem;
    font-size: 16rem;
    background: linear-gradient( 314deg, #f5f8ff 0%, #fff 100%);
    box-shadow: 2rem 2rem 5rem 0 rgba(133,161,224,0.2);
    border-radius: 16rem;
    border: 2rem solid #fff;
    flex-shrink: 0;
    &:not(:last-child) {
      margin-right: 40rem;
    }
    .label {
      margin-bottom: 12rem;
      color: #1e3aa2;
      display: flex;
      align-items: center;
      &::before {
        width: 16rem;
        height: 16rem;
        margin-right: 5rem;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA3hJREFUWEfFlTtoFF0Ux//nzmx8QRRFk7i7YEC+xsIHgmgh2ihKZtYIFhaCRazV1hRiY2usDQhaCFqYnREfhQoWouALxE7c4M6YmOLjI7DmizNzj8wkG2Z253EXBW+zzO655/875/znLOEvH/rL+ugJoDLiHSIhagwcCsEdS9sdflaM4DoRWkz8BV7w2nm46qNqYUoAZSO4QITLADa0EzMw7VracARgBpNEtGXlN+Y5lvKO+6D0tAgkF2DwBG/TpbwPYFdnojyAOIiniUvf79NcFkgmQNXwTzDRzXjV8SQqAFE8c0tycN21+16lQaQCLIuHlWceZYDlDFL6V9MgugCW2/4+q3IVD6RSM7d+auJ85zi6AMpm0CBgW5F5eu1ANA1ww6lr5+O5EwBlwz9LS3MvPsxTjq2PhoFVIxiHoH3Fl0IKOdm0dKsdmwRQqJ6ACU2IK9NT9F9ccGCUt5QkTAKbuSDMraalne4CCJcMhHieazzGRdfWJvJiqqZvgsRYvoG9cae+tKxWOlA1g2sMXMh5XyealnZRpc2VGo/ldYIhLaeuTyYAKoZ8DuJoxaYdX4jh2SmaVgEYOMLr+tbwnaxYltxw7CUzrnSgYgbvObZqE05l+uDYIjKc6qnWgnFmRKu66zBaXQCqif90nNKf0Z8WTXS3/TBk8kHB0NPEJGF+xqI3vYBsNfyaYGxOnQBh0bX12wkPLAP0Z4m43/AEb8lTgdh4jPvXleS5rFjJ3HRt/W4CYNDgHRoyTAMgABqzNn1SASib3mEBsScTAPKda5WinbPigfIob4KP/XkCPvDpu02NvJihEd6jC3k4Lyagxbvf6mubCYDwYajGR4VEKfcy0NBX44tzjxbicduP8aqFkn8gr/IwnsHzjqXfaN9NvAUDBg/rwA6VNkvCbNuYoeE0ou0q94jF46+xUXa9hkVmjIn8cG16Fj5XRvwxErS+CKCz+q4RRMlO8ZrgJw4WjQJATwAMLP7wxK1/H9F86h6If7n5OA/2adhbUFGPAKLuWPS5M2fmJgwh9BJ25nRCCSCsHBCP08RTRxAnDMfB/0ev5tqUbhQCSBZzCz7qnW0vHEGnWPkkV+Dhnw6QTICw6kCKlzMP6F2RMXv6MwqXVeBjUGP0S4HSjEUvQoGy4Z+JhIgdJu9ze8kUiReOQCXB78b01IHfFUu7/wveq4kw8c9T8QAAAABJRU5ErkJggg==');
      }
    }
    .value {
      color: #1c4efd;
      display: flex;
      align-items: center;
    }
    .num {
      min-width: 90rem;
      font-size: 30rem;
      font-weight: 700;
    }
    .unit {
      margin-left: 20rem;
    }
  }
}
.info-item-title, .show-item .label {
  &::before {
    content: '';
    display: inline-block;
    background-size: cover;
  }
}

.info-item-title {
  .pl & {
    padding-left: 10rem;
  }
}
.full-box {
  height: 440rem;
}
.small-box {
  height: 550rem;
}
.inner-box {
  width: 100%;
  height: 100%
}
.list-item {
  display: flex;
  line-height: 34rem;
  color: #3C3C3C;
  &.bg {
    color: #1e3aa2;
    background-color: #aac4ff33;
  }
  .td {
    padding-left: 20rem;
    flex: 1;
    // &:first-child {
    //   width: 80rem;
    // }
    // &:not(:first-child) {
    //   flex: 1;
    // }
  }
  .num {
    display: flex;
    align-items: center;
  }
  &:nth-child(-n + 4) .num::after {
    content: '';
    width: 24rem;
    height: 24rem;
    display: block;
    background-size: cover;
  }
  &:nth-child(n + 5) .num::after {
    content: attr(data-num);
    width: 20rem;
    height: 20rem;
    color: #fff;
    font-size: 14rem;
    background-color: #AAC4FF;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2rem;
  }
  &:nth-child(2) .num::after {
    background-image: url("data:image/png;base64,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");
  }
  &:nth-child(3) .num::after {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAACttJREFUaEOlWntsm9UV/93vsx07ifOO0zhJ8xhtISFO2iRjfQLFJuOpDYQ0Jg0hJrENDU17CKRt2ioIQ9qmbdK0IcEQYmLShnhs/MG0JmlaSAut26RJ2tLSpmlI87ITx/Ej8fO741zbidv68cU9/1Ttd8/jd8+55+UypKC3m6Err2EfAtic6nu2f2Oc9+zvw9+Tz/EDzbqFSOmnACvMxp/6O/9ZZc/RD67/xtIJ67XiKYmx13NThstSmG+7+zAiCf6FX+x5hjP8JRd5DPis/MXBFsbAVQN4+zHI5W72GYAtuSjlCv+etR+vEi8/cJd+MRq5yDlqc5ElgT1W3vPxO6l403qADh+y4tucsX/kopQDUyEN33L/fxF0/HLPjxjwp1zkABit7BlsS8ebEQAA1m9jZwA056Sc82db2i1vyPqiiwCqc5HBJPaNihc+/k+uANBrxaMSYyndp8Kg6daOO15hGk2PirM3HGHAqYqewc5MvNk8IHj7bew0gLRuTKdAkmXc1t61KmtkQy4AZEgPlPV8RNkwLakCcMiGhzlYWjemk24y12JTXX0utoMBn1b0DO7MxqwKAAnpszE7AzK6M1mZLGuwrX0HNBptNhtSfpckfm/5C0d7szGrBtB/L+4DF8VNFVXV1KGqNqc6SMl+0NQzuFeNItUAxFu4lx0DR1a3yoZCNHbdCWYwgkMCU8LQBr3QBL1qbAIUvr/yN0cH1BzeEIC+e2BlErvRrbp8oLED/HYrUNMMVNYDmrwb9GsDbug9szA6zsE4fxZ679yNNnIMVL40uF+N8XRmQwDiGenIlzVun1BQZALf+Tiw/UGg2KRWpzjHlCgKFi/BdPEgCh3nkegSOOd7TS8dHVQrbMMADtlwJ9caDvOd3wL2PQkUlGbUxTkHY5nVFDo+Q82Zd5HnmT5o6jnardb4nDzQZx9twuyFUzBvK0lWpCgcntUAXD4/fMEQguEwwtEoOAdkSUKeRoZep0VpQT5KCgzQa6/NTnJ4BXme+d/t6n74eYDd0LSlA7UhD/SePL2HMemf4KhJCIxEFcy5PZhf9iAQXms+M16ixJgAUVtWCqPh2rfCgD9L5cbn7m5sDKjxhGoA/zsxuk+S+DsMrDIheNHrxxWnC4FweE1Xfp4ORn0eCg150EoyKHqiCsdqOAzvSgDeQBBRRYm9A8ZgKjKivrIUWllek8GA1zYZ5B+2tLSEsoFQBeDg8PAWFpWPsHhDRuHyxaILM65l0aDTjVYYC1FdWoRC/Y3ZJ9mISDSKBa8fM0vLWA3FgBt0WmwzV6EgT5d0lL9s7Wz7+U0DGDx/3hj0hXo5cAcJUzjH+PwCHMuxnE4Gf6WqIqvh1xtCXph2LWNmyS08pNPIuNVcBaNBHz/Kw1ySH7ftuP3dTCCyeqDXPnKAMfbrhJAJx6K4PSJTsRGNpnJoJCnbRaX9vuRfwcVZp3jwBKK1ziwee5ymokHe2b27zZHTIx44dfaWKI/aAYiM4/T48PlsTFZVsRFNVRUifG6GyKMu3yrG552g8CIPtNRuEpmLiHP80dZl+UlOAPpPjv2Vg/+AmMORKE5PXkUoEkWRQY/mJCXXC9fIMoz5euh1OgRCIawGw+LP64mM96yGRFjS9wnHgjjSUFmGmrK1LO0OBiPtD+zeMZkKRNrr+2hoqDKkaC4AEJVq0rmIq65lcTOWzWZQtklFdaYKNJlNIBDJNLu4hM+nZsUtEyUbnzjn9Hiw4PGJjLS9oRZazZqMX1k7LS9uCECvfeQJxtibxBRRFAxdnhJxSpmmyVSR1vitdeuT42owBEMSUAJx7srVlMYLUIqCS3MOkWYbKstRU1Ys9DDgzP6OVsuXb1H9VqLPPvIBGHuIBCx4fbgw4xDx3t5QK9JeKtrduk2EDdHxcxfhWw2Iv9/RfMuaRwaGz4qYJw+kIueyR+gr0OvQXr++xOAhWGy7LGPX86QMoQMHuLT3wbFJjtga5MLMvMjdFPutm80pFZcaC7Bja5P45nR7MDq+HrLNDbWoLo/1TP3D5+Dy+lPKoH8MhSMYn48lio6muqSWgz9p7WwTEZFMKQH0D52r50rkSuLg0MSUKDp15aXYXJG6eUs8XOK5/tESMAJI1Dt0Fm7fSloA4sKmZ4WHqC6Ux/k4+Gu2zranVQE4ZD+zW2GKaGkpHo9fmgR1lbfVVKGsMGaIWqIQotAiIsMJQDa6uuCCNxAQl0WXRsSBD22dlgdUAeg/MfIQl5jYQwYjEZwc/0LwUfZZr5TZzICIe4r/xLs4PHIezngFz8Q9t+QGFbhNJUWiyscRfGLtsuxSBaD3xOlHmCSJEk6N2qnLU4Kvvb4GBVl6nWQFyaFzbnIGZyens6MGMO9eFm05FctbNsV7Rwa7tcPyVVUA+u2j93EGMcCHIhHY4x6gMl+Un+hVMtuS/HCvzC3A/vmEKuPp0OzSEtz+VVSXFIlqH3fBx9bOttgkmEQpH/HBobFOSeHUQojYP37pimi4tlabUFmUfTtOtYAKGtFGjRc8DqdIGo2V5TDHa8GXi7X3rZ2WR1QBiFVheQZgGmIYmZyGLxC8NibT3GeTuQqN1bH5WO2jTRbFwXHh6qxo01tqq8XgI4jht9YOy/OqANChvlOjZ8FjS93LjgXMLnmQr9OhvaEm7YybbDz1TvYLEyIEk4mqeaY06g8E8cXCIiSJobNpc/Kg801rp+Xf6gHYR18Hw1PEsLyyijNTs4L39jozilO8A8rbtk5L1jh3ur04PHo+7blplwuelYC4efKAII6AHOVb7v5a29UNABizgfGDiXdwenIaK8HQtYLj0hKN2aN7s28eMwEIRcIYn3MKqbfWVKE8XnM4xxFbl+WuVKjTdqMDExP66KJ3BMBWYqQJ7GJc+DazSYyQRKm6yqxuSHNgamFRvDUaLS31NeuzBmPfsXa0vrUhAHT40KnRHyscf0gYemZqBt7VYGxy2myGTqNZ6+dzNTrB5/avYHbJLd4XVXxav8RpXB/Qbd+z59aUe8mM49T7A8MlxiLNCXAufifzB0MgELRKoQfdUFUh9j43S75AAFMLLiHm2twPcIanbR2W19LpyDoP9tpHHmWM/QuAmC5orLw05xShQyBqK8rWxr9cgCzHb57ugR4uNXCJcZIxHAkWGbrv37IlmDMAYuw9OfYKA/9+Qsj8sleMf1TcaKDfVFYCo15dhU7IoCaReh7a5hGV5Buw1WxKTpsOifN9+7vaaCpMS1k9EANwsphB+x7A1rbGLt+KGMRpRiaiEbM434Di/PyMu9BQOAyX3y9aBaryRNTz0ASmkde2Gz7G2BP3dLS+n82rqgCQkL5Px6qgxXvgfK0jpCI16XSJYSd5wjLodGJqW98scAHUH1zfypFMOkMtcyKjxY31M4Zn7+mwvJHNePquGgAd/nBoqFIblf/GGHs4WTilvlm3B0u+FTE3Z3M5LcOqSopQYSy45v0wBidX+DPWrjbVv4puCAAZduzYMYNfW/AcY+ynAIzJxlJcExhKtSuhkFgGUJiQJyj10ixRmJeXcqZmwHGmUb67v709+8STpHTDABK8vfbT25kkvwzABs5zX82Bz3DOfq+4+Kvd3W3ph+U0bs0ZQEKeGD8RfRaM0Q8T1/xmkCGU6PUOA/zNSEjz1td3tcSKQA500wASOgeGh0sULu/kHHdB4a1grIbHlmIaxpiPK4oDjF0BwxFF4Z90d7XRf2G4afo/TG1qbRyvmDgAAAAASUVORK5CYII=");
  }
  &:nth-child(4) .num::after {
    background-image: url("data:image/png;base64,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");
  }
}
.page-tabs {
  display: flex;
  &-item {
    height: 44rem;
    padding: 0 16rem;
    font-size: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f6f9ff;
    border-radius: 6rem;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: #eee;
    }
    &.active {
      color: #1C4EFD;
      background-color: #e3eaff;
    }
  }
}
::v-deep {
  .el-table th.el-table__cell {
    background: #f6f9ff;
  }
}
</style>
